// Auto-refactored from translations.js on 2026-08-19
// Locale: hu

const hu = {
  wieMoeglich: { question: 'Hogyan lehetséges ez?', answer: 'Újragondoltuk az értékláncot.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'A STIG ROCK út',
    fazit: 'A lerövidített ellátási lánc révén megszűnnek a legnagyobb költségtételek.',
    fazitBigPre: 'Az így elérhető árengedmény akár',
    fazitBigValue: '80%',
    steps: [ 'Bánya', 'Csiszolóműhely', 'Tanúsítás', 'Végfelhasználó' ]
  },
  nav: { language: 'Nyelv', contact: 'Kapcsolat' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Egy egyedülálló lehetőség',
    subtitle: 'Jövőorientáltan építsd vagyonod.',
    description: 'A STIG ROCK egy nemzetközi platform, amely természetes gyémántokhoz, fenntartható vagyonépítéshez és egy egyedülálló közösséghez biztosít hozzáférést az emberek számára.',
    scroll: 'Görgess a felfedezéshez'
  },
  disclaimer: {
    overline: 'Jogi figyelmeztetés',
    title: 'Felelősségi nyilatkozat',
    paragraphs: [
      'Ez a bemutató kizárólag tájékoztatási célt szolgál, és nem minősül pénzügyi, befektetési vagy adótanácsadásnak.',
      'A STIG ROCK nem pénzügyi termék, hanem természetes gyémántokra vonatkozik, mint tárgyi értékekre.',
      'Értékfejlődésre, nyereségre vagy hozamra semmilyen garanciát nem vállalunk. A múltbeli teljesítmények nem mutatnak előre jövőbeli eredményeket.',
      'A jutalékokkal kapcsolatban bemutatott összes számítás csupán példaértékű, és szintén nem jelent garanciát.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'STRUKTÚRÁRA', 'ÉPÍTVE' ],
    body: 'A STIG Group egy nemzetközi konszern, amely az egyértelműségre, felelősségre és hosszú távú értékre épül. Minden márka, minden vállalkozás és minden partnerség egyetlen standardot követ — rövidítések és kivételek nélkül.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'STRUKTÚRÁRA', 'ÉPÍTVE' ],
        body: 'A STIG Group egy nemzetközi konszern, amely az egyértelműségre, felelősségre és hosszú távú értékre épül. Minden márka, minden vállalkozás és minden partnerség egyetlen standardot követ — rövidítések és kivételek nélkül.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'AZ EXKLUZÍV', 'GYÉMÁNTOK VILÁGA' ],
        body: 'A STIG ROCK a STIG Group modern koncepciója, amely a magas minőségű GIA-tanúsított gyémántokat átlátható struktúrákkal és exkluzív ügyfélélménnyel ötvözi. Egyértelmű megoldási tervek, professzionális lebonyolítás és nemzetközi orientáció.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'NEMZETKÖZI', 'GYÉMÁNTKERESKEDELEM' ],
        body: 'A STIG International a STIG Group része, és a GIA-tanúsított gyémántokkal való nemzetközi kereskedelemre specializálódott. Fókuszban a minőség, bizalom és modern kereskedelmi struktúrák állnak, globális partnerségekkel.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'FELELŐSSÉG', 'A BÁNYÁTÓL KEZDVE' ],
        body: 'Az Ethical Mines a felelős bányászatot, nyomon követhető eredetet és konfliktusmentes gyémántokat jelent. A bányától a piacig — teljes körű dokumentáció az átláthatóságért, integritásért és hosszú távú felelősségért a teljes ellátási lánc mentén.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Gyémántok',
    stigDrawback: 'Valódi értékmegőrző',
    overline: 'Lehetőségek',
    title: 'Lehetőségek a vagyonépítéshez',
    subtitle: 'Hagyományos utak összehasonlításban.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex vagy kriptó',
        drawback: 'rendkívül spekulatív, kiszámíthatatlan, összetett'
      },
      {
        tag: 'Részvények',
        name: 'Tőzsdei kereskedelem',
        drawback: 'ingadozási kockázat, szükséges tudás, időráfordítás'
      },
      {
        tag: 'Kriptó',
        name: 'Kereskedelem',
        drawback: 'volatilitás, szabályozási kockázat, biztonsági rések'
      }
    ]
  },
  chance: {
    overline: 'Gyémántok',
    title: 'Az alábecsült lehetőség',
    body: 'A gyémántok évek óta a legértékállóbb és legígéretesebb befektetési formák közé tartoznak, mégis eddig csak kevesen használták ki ezt a potenciált.',
    callout: 'STIG ROCK platformunkkal most először mindenki számára megnyitjuk a hozzáférést ezekhez a kivételes lehetőségekhez.'
  },
  wertentwicklung: {
    overline: 'Értékfejlődés 1995 — 2025',
    title: 'Egy történet az értékről.',
    usd: 'USA dollár',
    usdValue: '-49%',
    diamond: 'Gyémántok',
    diamondValue: '+185%',
    note: 'Fejlődés 1995 — 2025 között'
  },
  hauptgruende: {
    overline: 'Fő okok',
    title: 'Hat ok a gyémántok mellett',
    lead: 'A gyémántok valódi tárgyi értékek, amelyek függetlenek a valutáktól és pénzügyi rendszerektől — és évszázadok óta megőrzik értéküket.',
    items: [
      {
        n: '01',
        title: 'Válságálló értékállóság',
        body: 'Tárgyi érték garancia. Független a valutáktól és pénzügyi rendszerektől.'
      },
      {
        n: '02',
        title: 'A végső mobilitás',
        body: 'Kicsi, könnyen elrejthető és szállítható.'
      },
      {
        n: '03',
        title: 'Diverzifikáció & szűkösség',
        body: 'Kínálati szűkösség és természetes korlátozottság.'
      },
      { n: '04', title: 'Hosszú távú növekedés', body: '+185% 1995 óta.' },
      {
        n: '05',
        title: 'Átláthatóság & exkluzivitás',
        body: 'A 4 C garanciaként: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Királyi házak tartaléka',
        body: 'Még a királyi házak is gyémántokat használnak vagyontartalékként.'
      }
    ]
  },
  markt: {
    overline: 'Piaci volumen',
    title: '99 — 108 Mrd. USD',
    sub: 'Kereskedelmi forgalom 2025-ben',
    unit: 'Mrd. USD',
    forecast: 'Előrejelzés 2032/2034-ig: kb. 140 – 168 Mrd. USD mérsékelt növekedés mellett (~4 – 5% évente).',
    source: 'Forrás: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innováció',
    title: 'Egy innováció. Először a világon.',
    body: 'A STIG ROCK az első platform a világon, amely lehetővé teszi az emberek számára, hogy a gyémántpiacon az értéknövekedés mellett passzív jövedelmet is termeljenek.',
    leadershipTag: 'Vezetőség · Kapcsolat',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, EAE',
      'Cégjegyzékszám: DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Vezérigazgató' },
      { name: 'Michael Lang', role: 'COO — Operatív igazgató' }
    ]
  },
  globalNetwork: {
    overline: 'A vállalatról',
    titleLines: [ 'NEMZETKÖZI', 'STRUKTÚRA', 'VILÁGOS VÍZIÓ' ],
    body: 'A STIG ROCK azért jött létre, hogy a gyémántpiacot átláthatóbbá, modernebbé és ügyfélközpontúbbá tegye — a bizalomra, biztonságra és hosszú távú struktúrára összpontosítva.'
  },
  dualTimeline: {
    overline: 'A DUAL RENDSZER · VIZUÁLIS',
    title: 'Egy vásárlás, két út.',
    intro: 'A te gyémántod biztonságban van — közben egy második vállalati gyémánt dolgozik.\n' +
      'Évente négy kereskedelmi ciklus generálja a kedvezményt anélkül, hogy a gyémántodat valaha is kereskednék.',
    customer: {
      kicker: 'IDŐVONAL 1',
      title: 'STIG ROCK\nAz ügyfél',
      sub: 'Nyers alapanyagtól a kiszállításig',
      purchase: 'Vásárlás',
      cut: 'Csiszolás',
      certify: 'Tanúsítás',
      delivery: 'Kiszállítás'
    },
    stig: {
      kicker: 'IDŐVONAL 2',
      sub: 'Egy második vállalati gyémánt · négy ciklus · aktív kereskedelem',
      cycleSteps: [ 'Vásárlás', 'Tervezés', 'Csiszolás', 'Értékesítés' ],
      footerCycle: '4 × Vásárlás-Csiszolás-Értékesítés',
      footerDiscount: 'Kedvezmény → Ügyfél'
    },
    summary: {
      stored: 'A gyémánt biztonságosan megőrizve',
      cycles: 'Kereskedelmi ciklus évente',
      months: 'Hónap futamidő'
    }
  },
  kimberleySlide: {
    overline: 'Kimberley folyamat',
    title: 'Kizárólag konfliktusmentes gyémántokkal dolgozunk.',
    body: 'A Kimberley Process egy nemzetközi tanúsítási rendszer, amely megakadályozza a konfliktusgyémántok kereskedelmét. A STIG ROCK minden köve hiánytalanul visszakövethető és felelős, tanúsított forrásokból származik.',
    sealAlt: 'Kimberley Process — Hivatalos pecsét'
  },
  zertifiziert: {
    overline: 'GIA · Tanúsítás',
    title: 'Tanúsított és átlátható',
    body: 'Minden gyémánt megfelel a legmagasabb minőségi standardoknak, és elismert szervezetek ellenőrzik és tanúsítják. Minden kő egyedi és egyedi tanúsítványt kap.',
    kimberley: 'Kimberley Process — kizárólag konfliktusmentes gyémántokkal dolgozunk.'
  },
  sicherheit: {
    overline: 'Minőség & biztonság',
    title: 'Gemological Institute of America',
    headline: 'Tanúsított szakértelem az Ön gyémántjaihoz.',
    p1: 'A GIA a Gemological Institute of America rövidítése — a világ vezető, független és non-profit gyémántértékelő intézete, valamint a globális 4C-standard (Carat, Clarity, Color, Cut) megalkotója.',
    p2: 'Egy GIA-tanúsítvány garantálja egy gyémánt eredetiségét és természetességét, valamint minőségi jellemzőinek objektív, megvesztegethetetlen dokumentálását.',
    p3: 'Az ügyfél számára ez maximális biztonságot és bizalmat jelent: pontosan tudja, mit vásárol, tisztességes és minőségének megfelelő árat fizet, valamint egy világszerte elismert, értékálló és bármikor újra eladható gyémánt tulajdonosa lesz.',
    body: 'Tanúsított szakértelem gyémántjaidhoz. A GIA minden követ a legnagyobb precizitással és hosszú éves tapasztalattal értékel — megbízható értékbecslések vállalatunk és ügyfeleink számára.',
    transparency: 'Minden gyémánt megfelel a legmagasabb minőségi standardoknak, és elismert szervezetek ellenőrzik és tanúsítják. Minden kő egyedi és egyéni tanúsítványt kap.',
    kimberley: 'Kimberley Process — kizárólag konfliktusmentes gyémántokkal dolgozunk.'
  },
  plaene: {
    overline: 'Solution tervek (SP)',
    title: 'Egy egyedülálló termékinováció',
    sub: 'Hét Solution terv — $250-tól $100K+-ig,\n' +
      'mindegyik növekvő havi kedvezménnyel az egész futamidő alatt.',
    recommended: 'Népszerű',
    oneYear: '1 év',
    rowLabels: {
      delivery: 'Szállítási idő',
      price: 'Termék ár',
      carat: 'Karát',
      monthly: 'Kedvezmény (havi)',
      totalDiscount: 'Kedvezmény (összesen)',
      duration: 'Futamidő'
    },
    headers: {
      plan: 'Terv',
      from: 'Től',
      carat: 'Karát',
      monthly: 'Kedvezmény / hó',
      total: 'Kedvezmény összesen',
      duration: 'Futamidő'
    },
    duration: '1 év',
    footnote: 'Minden áradat fenntartással kezelendő, és függ a minőségtől, kereslettől és az aktuális piaci fejlődéstől. A Solution tervek 2 évre is elérhetők.'
  },
  plaeneVIP: {
    overline: 'Solution tervek + VIP-csomag',
    title: 'VIP-csomaggal még több kedvezmény',
    sub: 'Összesített kedvezmény tervenként — VIP-csomaggal kombinálva +1% - +3% további kedvezményt kapsz, ami érezhetően növeli az összkedvezményt.',
    rowLabels: {
      delivery: 'Szállítási idő',
      price: 'Termék ár',
      carat: 'Karát',
      monthly: 'Kedvezmény (havi)',
      totalDiscount: 'Kedvezmény (összesen)',
      vip1: 'VIP-csomag 1 (+1%)',
      vip2: 'VIP-csomag 2 (+2%)',
      vip3: 'VIP-csomag 3 (+3%)'
    },
    footnote: 'Minden áradat fenntartással kezelendő, és függ a minőségtől, kereslettől és az aktuális piaci fejlődéstől.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'A te lehetőségeid',
    sub: 'Solution terved lejárta után hazaszállíttathatod a gyémánt(jaid)at, vagy továbbadhatod őket.',
    options: [
      {
        key: 'deliver',
        title: 'Kiszállíttatás',
        body: 'Gyémántok (karát) a DS-terved árán*'
      },
      {
        key: 'sellToUs',
        title: 'Értékesítés nekünk',
        body: 'Gyémántjaidat visszaadhatod nekünk az általad kifizetett vételáron.'
      },
      {
        key: 'sellThirdParty',
        title: 'Értékesítés harmadik félnek',
        body: 'Gyémántjaidat harmadik félnek értékesítheted tovább.'
      },
      {
        key: 'offer',
        title: 'Automatikus vételi ajánlat',
        body: 'Vételi ajánlat 4 héttel a szállítás előtt — automatikusan megjelenik a Solution terv lejárta előtt!'
      }
    ],
    footnote: '*DS-terv a Solution tervet jelenti.'
  },
  tradWeg: {
    overline: 'Hagyományos kereskedelem',
    title: 'A hagyományos út',
    sub: 'Mielőtt egy gyémánt eljutna a végső fogyasztóhoz, a közvetítő-, nagy- és kiskereskedelem révén jelentős kereskedelmi árrések keletkeznek a bányából származó nyers gyémánt árához képest.',
    steps: [
      { title: 'Bánya', subtitle: 'Nyers gyémántok' },
      { title: 'Közvetítő kereskedő', subtitle: 'Nyers gyémántok beszerzése' },
      { title: 'Csiszolóüzem', subtitle: 'Csiszolás ékszergyémántokká' },
      { title: 'Tanúsítás', subtitle: 'elismert intézetek által, mint a GIA' },
      { title: 'Gyémánttőzsde', subtitle: 'Értékesítés nagykereskedőnek' },
      { title: 'Nagykereskedelem', subtitle: 'Értékesítés kiskereskedőnek' },
      { title: 'Kiskereskedelem', subtitle: 'pl. ékszerészek' },
      { title: 'Végső vásárlók', subtitle: 'Gyémántok vásárlása' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'A STIG ROCK út',
    sub: 'Mi megtörjük ezt a kört azzal, hogy a nyers gyémántokat közvetlenül a bányából vásároljuk, partnereink által csiszoltatjuk és tanúsíttatjuk. Ezáltal ezeket a kereskedelmi árréseket kedvezményjóváírások formájában továbbadhatjuk ügyfeleinknek.',
    duration: '12 hónap – DS-terv futamidő',
    centerBig: '04',
    centerCaption: 'Akár 4 kereskedelmi ciklus a DS-terv futamideje alatt',
    cycle: [
      { n: '1.', title: 'Több nyers gyémánt vásárlása', body: 'egy DS-tervhez' },
      { n: '2.', title: 'Csiszoltatás és tanúsíttatás', body: 'partnereink által' },
      { n: '3.', title: 'Értékesítés végső vásárlóknak', body: 'és nagykereskedőknek' },
      { n: '4.', title: 'Ezt a folyamatot megismételjük', body: 'akár 4× évente' },
      {
        n: '5.',
        title: 'További bevételek',
        body: 'A nyereség bányalicencekbe, a nyersgyémántok kitermelésébe és a felvásárlásba folyik – STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Bánya', subtitle: 'Nyers gyémántok' },
      { title: 'Csiszolóüzem', subtitle: 'partnereink által' },
      { title: 'Tanúsítás', subtitle: 'elismert intézetek által' },
      { title: 'Végső vásárlók', subtitle: 'Vásárlás & kedvezményjóváírások' }
    ],
    footnote: '*DS-terv a Solution tervet jelenti.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-csomagok',
    sub: '12 hónapig érvényes minden általad aláírt Solution tervre. VIP-csomagtól függően: +1% - +3% további kedvezmény',
    cardKicker: 'további – minden',
    cardKicker2: 'Solution tervre',
    tip: 'Ajánlás: 2 800$ befektetési volumentől a 3. VIP-csomag éri meg a legjobban.',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'A kedvezményekből megtakarítások lesznek',
      body: 'Havi megtakarítás havi teher helyett. A kedvezményekből megtakarítások lesznek – és ezek pontosan azokat a dolgokat fizetik, amelyekért egyébként minden hónapban a saját zsebedből fizetnél.',
      line1Label: 'DS-terv ettől',
      line1Value: '$5.000',
      line2Label: 'havi kedvezmény',
      line2Value: '3%',
      line3Label: 'VIP-csomag 3',
      line3Value: '+3%',
      resultLabel: 'havi megtakarítások',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Hogyan lehetséges ez?',
    title: 'Újragondoltuk az értékteremtő láncot.',
    traditionalTitle: 'A hagyományos út',
    totalLabel: 'Végfelhasználói ár',
    traditionalSteps: [
      'Bánya — Nyers gyémántok',
      'Közvetítő kereskedő — Beszerzés',
      'Csiszolóüzem — Csiszolás',
      'Tanúsítás (GIA)',
      'Gyémánttőzsde — Nagykereskedelem',
      'Nagykereskedelem → Kiskereskedelem',
      'Ékszerészek → Végső vásárló'
    ],
    traditionalNote: 'Mielőtt egy gyémánt eljutna a végső fogyasztóhoz, a közvetítő-, nagy- és kiskereskedelem révén jelentős kereskedelmi árrések keletkeznek.',
    stigTitle: 'A STIG ROCK út',
    stigSteps: [
      'Közvetlen vásárlás — Nyers gyémántok a bányából',
      'Csiszoltatás & Tanúsíttatás partnereink által',
      'Értékesítés végső vásárlóknak & B2B ügyfeleknek',
      'Akár 4 kereskedelmi ciklus évente'
    ],
    stigNote: 'Mi megtörjük a kört, és a kereskedelmi árréseket kedvezményjóváírások formájában adjuk tovább ügyfeleinknek — akár 4 kereskedelmi ciklus a DS-terv futamideje alatt.'
  },
  optionen: {
    overline: 'A te lehetőségeid',
    title: 'Solution terved lejárta után',
    items: [
      { title: 'Kiszállíttatás', body: 'Gyémántok (karát) a DS-terved árán.' },
      {
        title: 'Értékesítés nekünk',
        body: 'Visszaeladás az általad kifizetett vételáron.'
      },
      {
        title: 'Értékesítés harmadik félnek',
        body: 'Gyémántok értékesítése a szabad piacon.'
      }
    ]
  },
  einfacherWeg: {
    overline: 'Solution tervek — egy egyedülálló termékinováció',
    title: 'Az egyszerű út',
    caption: '3 · lépés · a sikerhez',
    captionParts: { count: '3', middle: 'lépés', end: 'a sikerhez' },
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Regisztráció',
        body: 'Vedd fel a kapcsolatot ajánlóddal, és hozz létre egy ingyenes fiókot!'
      },
      { n: '02', icon: 'cart', title: 'Termék vásárlása', body: 'Már $ 250,-tól' },
      {
        n: '03',
        icon: 'discount',
        title: 'Kedvezmények fogadása',
        body: 'Kapsz havi kedvezményjóváírásokat.'
      }
    ]
  },
  business: {
    overline: 'Bónusztípusok',
    title: 'A legegyszerűbb és legméltányosabb út.',
    sub: 'Öt bónusztípus — sikeres üzletépítésedhez.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: '3. szintig, Pearl / Ruby karrierfokozattól.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Sapphire-től — végtelenül mélyen.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Az Infinity Bonus után – 5. szintig · MINŐSÍTÉS NÉLKÜL.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: 'A világszintű forgalom 3 medencéje.'
      },
      {
        name: 'Rangbónusz',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Egyszeri bónusz gyémántokban (karát).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Ezt a bónust minden új Solution tervért a 3. szintig kapod. Nagyon alacsony kvalifikációkkal oldod fel az egyes szinteket.',
    total: 'Akár 18% Unilevel Bonus',
    totalParts: { prefix: 'Akár', big: '18%', suffix: 'Unilevel Bonus' },
    levels: [
      {
        level: '1. szint',
        value: '10%',
        qual: 'kezdettől fogva',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: '2. szint',
        value: '5%',
        qual: 'Pearl karrierfokozattól',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: '3. szint',
        value: '3%',
        qual: 'Ruby karrierfokozattól',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'A Sapphire karrierfokozattól kvalifikált vagy az Infinity bónustervünkhöz. 3% bónuszt kapsz. Minden új karrierfokozattal további százalékok jönnek. Ha csapatodban egy partner szintén kvalifikált, a rangok közötti különbözetet kapod.',
    exampleTitle: 'Példa',
    exampleRows: [
      { label: 'Te Blue Diamond vagy', value: '12%' },
      { label: 'Partnered Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Az Infinity Bonus-od', value: '9%' },
    totalNote: 'Összesen akár 24% Infinity Bonus minden aláírt Solution tervre csapatodban — végtelenül mélyen.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Ezzel a bónusszal profitálsz csapatod sikeréből. 5% Matching Bonus-t kapsz partnered Infinity Bonus-ára — és ez a csapatod 5. szintjéig tart.',
    note: 'Minden Infinity Bonus kifizetésre csapatodban – az 5. szintig. Kezdettől fogva – MINŐSÍTÉS NÉLKÜL.',
    levels: [
      { level: '1. szint', value: '5%' },
      { level: '2. szint', value: '5%' },
      { level: '3. szint', value: '5%' },
      { level: '4. szint', value: '5%' },
      { level: '5. szint', value: '5%' }
    ],
    totalPrefix: 'Összesen akár',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: 'A világszintű forgalom 3%-a egyenlő részekben 3 különböző medencébe folyik. Bizonyos karrierfokozatok elérésével minden egyes medencéhez kvalifikálsz.',
    forever: 'Egyszer elérve – ÖRÖKRE részesülsz!',
    pools: [
      { key: 'p1', label: '1. Pool', value: '1%', qual: 'Blue Diamond-tól' },
      { key: 'p2', label: '2. Pool', value: '1%', qual: 'Purple Diamond-tól' },
      { key: 'p3', label: '3. Pool', value: '1%', qual: 'Double Diamond Elite-tól' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Összesen',
    totalValue: '3%',
    totalSuffix: 'a világszintű forgalomból'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rangbónusz',
    title: 'Rangbónusz',
    sub: 'A Diamond karrierfokozattól Rangbónuszt kapsz. Ez gyémántokban (karát) kerül kifizetésre. Ez egy egyszeri bónusz.',
    highlight: 'Gyémántok (karát) összértéke',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierfokozatok',
    title: 'Karrierfokozatok',
    sub: 'Az egyes karrierfokozatok eléréséhez a történelmi összforgalom (HG) számít. Ezt a Sapphire fokozattól több csapatra kell elosztani. Ruby vagy magasabb eléréséhez legalább két közvetlen partnerre van szükséged Solution tervvel.',
    forever: 'Egyszer elérve – ÖRÖKRE megerősítve!',
    footnote: 'HV = Történelmi összforgalom. **Elosztás: egy csapat maximális részesedése a HG-ből.',
    distributionLabel: '**Elosztás:',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', dist: '', perks: [ '1 Unilevel' ] },
      {
        name: 'Pearl',
        coin: 'image83.png',
        hg: '250 HV',
        dist: '',
        perks: [ '2 Unilevel' ]
      },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        dist: '',
        perks: [ '2 közvetlen partner', '3 Unilevel' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        dist: '60%',
        perks: [ '3 Unilevel', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        dist: '60%',
        perks: [ '3 Unilevel', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        dist: '50%',
        perks: [ '3 Unilevel', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        dist: '50%',
        perks: [ '3 Unilevel', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        dist: '40%',
        perks: [ '3 Unilevel', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        dist: '40%',
        perks: [ '3 Unilevel', 'Infinity 18%', '$100k Bonus', '2 Pool' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        dist: '30%',
        perks: [ '3 Unilevel', 'Infinity 21%', '$150k Bonus', '2 Pool' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        dist: '30%',
        perks: [ '3 Unilevel', 'Infinity 22%', '$1M Bonus', '3 Pool' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        dist: '25%',
        perks: [ '3 Unilevel', 'Infinity 23%', '$2M Bonus', '3 Pool' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        dist: '20%',
        perks: [ '3 Unilevel', 'Infinity 24%', '$5M Bonus', '3 Pool' ]
      }
    ]
  },
  cta: {
    overline: 'Indulj velünk',
    title: 'A megfelelő idő pontosan most van.',
    body: 'Ez az üzleti modell új mércét állít, és egyesíti a hosszú távon fenntartható és sikeres üzlet minden sikertényezőjét. Regisztrálj még ma, válaszd ki Solution tervedet, és használd ki ezt az egyedülálló üzleti lehetőséget.',
    hint: 'Beszélj azzal a személlyel, aki meghívott erre a bemutatóra — van egy regisztrációs linkje számodra.',
    formName: 'Név',
    formEmail: 'E-mail',
    formPhone: 'Telefon',
    formSubmit: 'Kapcsolatfelvétel',
    success: 'Köszönjük — diszkréten és személyesen jelentkezünk.',
    callCta: 'Hívás',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Jogi figyelmeztetés & Felelősségi nyilatkozat',
    disclaimer: 'Ez a bemutató kizárólag tájékoztatási célt szolgál, és nem minősül pénzügyi, befektetési vagy adótanácsadásnak. A STIG ROCK nem pénzügyi termék, hanem természetes gyémántokra vonatkozik, mint tárgyi értékekre. Értékfejlődésre, nyereségre vagy hozamra semmilyen garanciát nem vállalunk. A múltbeli teljesítmények nem mutatnak előre jövőbeli eredményeket. A jutalékokkal kapcsolatban bemutatott összes számítás csupán példaértékű, és szintén nem jelent garanciát. A tartalom változtatásának jogát fenntartjuk — szabad fordítás (nem hivatalos fordítás).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, EAE',
    copy: '© 2026 STIG International. Minden jog fenntartva.',
    version: 'Verzió: DS-12-2025 V3'
  },
  misc: { next: 'Következő szekció' }
};

export default hu;
